import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import {useHistory} from "react-router-dom"

import {selectSnackbar} from "../../redux/snackbar/snackbar.selector"
import {hideSnackbar} from "../../redux/snackbar/snackbar.action"

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const AppSnackBar = ({selectSnackbar,hideSnackbar})=>{
  const history = useHistory();
  const [open, setOpen] = React.useState(selectSnackbar.open);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    if(selectSnackbar.navTo)
      history.push(selectSnackbar.navTo)
    setOpen(false);
    hideSnackbar();
  };
  React.useEffect(()=>{
    setOpen(selectSnackbar.open);
  },[selectSnackbar])
  return (
    <div>
      <Snackbar open={open} autoHideDuration={2500} onClose={handleClose}>
        <Alert onClose={handleClose} severity={selectSnackbar.snackBarType || "success"}>
          {selectSnackbar.message}
        </Alert>
      </Snackbar>
      </div>
  )
}


const mapStateToProps = createStructuredSelector({
  selectSnackbar: selectSnackbar
});

const mapDispatchToProps = dispatch => ({
  hideSnackbar : ()=>{dispatch(hideSnackbar())}
});

export default connect(mapStateToProps, mapDispatchToProps)(AppSnackBar);
